<template>
  <div id="app">
    <div ref="headerStack" class="header-stack">
      <ShabbatBanner />
      <Header />
    </div>
    <main>
      <Hero />
      <Clients />
      <Features />
      <Contact />
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import Header from './components/Header.vue'
import Hero from './components/Hero.vue'
import Clients from './components/Clients.vue'
import Features from './components/Features.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'
import ShabbatBanner from './components/ShabbatBanner.vue'

const headerStack = ref<HTMLElement | null>(null)
let observer: ResizeObserver | undefined

onMounted(() => {
  if (!headerStack.value) return

  const updateOffset = () => {
    const height = headerStack.value?.offsetHeight ?? 0
    document.documentElement.style.setProperty('--fixed-header-offset', `${height}px`)
  }

  observer = new ResizeObserver(updateOffset)
  observer.observe(headerStack.value)
  updateOffset()
})

onUnmounted(() => {
  observer?.disconnect()
})
</script>

<style scoped>
.header-stack {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>
